import { defineComponent as d, useId as u, computed as l, createElementBlock as m, openBlock as c, createBlock as p, createCommentVNode as f, createElementVNode as h, unref as t } from "vue";
import { syntaxHighlight as g, standardLanguages as k } from "@scalar/code-highlight";
import { prettyPrintJson as r } from "@scalar/oas-utils/helpers";
import C from "./ScalarCodeBlockCopy.vue.js";
const _ = {
  class: "scalar-code-block group/code-block custom-scroll min-h-12 focus-visible:outline",
  tabindex: "0"
}, b = ["id", "innerHTML"], H = /* @__PURE__ */ d({
  __name: "ScalarCodeBlock",
  props: {
    content: {},
    lang: { default: "plaintext" },
    lineNumbers: { type: Boolean, default: !1 },
    hideCredentials: {},
    copy: { type: Boolean, default: !0 }
  },
  setup(a) {
    const e = a, n = u(), s = l(() => g(r(e.content), {
      lang: e.lang.trim(),
      languages: k,
      lineNumbers: e.lineNumbers,
      maskCredentials: e.hideCredentials
    }).slice(5, -6)), i = l(() => e.content !== null && e.content !== "null" && e.content !== "404 Not Found");
    return (o, y) => (c(), m("div", _, [
      o.copy && i.value ? (c(), p(t(C), {
        key: 0,
        content: t(r)(e.content),
        controls: t(n)
      }, null, 8, ["content", "controls"])) : f("", !0),
      h("pre", {
        id: t(n),
        class: "scalar-codeblock-pre",
        innerHTML: s.value
      }, null, 8, b)
    ]));
  }
});
export {
  H as default
};
